import React from 'react';
import { Container, Title, Text, SimpleGrid, Space } from '@mantine/core';
import { BlogCard } from './BlogCard';
import {blogPosts, BlogPostData}  from './blogData';

export function BlogList() {
  return (
    <Container mt="80px" size="lg" py="xl">
      <Title order={1} ta="center" mb="sm">Our Blog</Title>
      <Text c="dimmed" ta="center" mb="xl">
        Latest news, updates, and insights from our team
      </Text>
      
      <Space h="xl" />
      
      <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="lg">
        {blogPosts.map((post: BlogPostData) => (
          <BlogCard
            key={post.id}
            id={post.id}
            title={post.title}
            date={post.date}
            description={post.description}
            imageUrl={post.imageUrl}
            tags={post.tags}
            author={post.author}
          />
        ))}
      </SimpleGrid>
    </Container>
  );
}
